import Auth from '../views/Auth';
import AuthIndex from '../views/auth/Index';
import AuthForgot from '../views/auth/Forgot';
import AuthReset from '../views/auth/Reset';
import AuthRegister from '../views/auth/Register';
import PartnershipRegister from "../views/auth/PartnershipRegister";

export const AUTH_ROUTES = {
  path: '/auth',
  component: Auth,
  meta: {noauth: true},
  children: [
    {
      path: '',
      name: 'auth',
      component: AuthIndex,
      meta: { noauth: true }
    },
    {
      path: 'forgot',
      name: 'auth-forgot',
      component: AuthForgot,
      meta: { noauth: true }
    },
    {
      path: 'reset/:token',
      name: 'auth-reset',
      component: AuthReset,
      meta: { noauth: true }
    },
    {
      path: 'register',
      name: 'auth-register',
      component: AuthRegister,
      meta: { noauth: true }
    },
    {
      path: 'register/:referral',
      name: 'auth-register-referral',
      component: AuthRegister,
      meta: { noauth: true }
    },
    {
      path: 'partnership',
      name: 'auth-partnership',
      component: PartnershipRegister,
      meta: { noauth: true }
    },
    {
      path: ':name',
      name: 'auth-params',
      component: AuthIndex,
      meta: { noauth: true }

    },
  ]
};
